import { UsedComparables } from "./historyLeadInfo.endpoints";

export interface ComparablePricing {
  price_m2?: number;
  sale_value?: number;
}

/**
 * Mapea los comparables de get_last_price_info al formato que esperan
 * get_percentile_calculator y validate_tope.
 *
 * Prioridad de llaves (aplica a MX y CO):
 * - price_m2:   price_per_m2 -> price_m2_norm (MX automático) -> valormt2 (CO automático)
 * - sale_value: last_ask_price -> sale_value (MX automático)
 */
export const mapComparablesForPricing = (
  comparables?: UsedComparables[],
): ComparablePricing[] | undefined =>
  comparables?.map(
    ({
      price_per_m2,
      price_m2_norm,
      valormt2,
      last_ask_price,
      sale_value,
    }) => ({
      price_m2: price_per_m2 || price_m2_norm || valormt2,
      sale_value: last_ask_price || sale_value,
    }),
  );
